module.exports = __webpack_public_path__ + "img/loading-circle.c5a8b8b9.svg";